const debounce = (func: (...args: any[]) => void, wait: number) => {
	let timeout: ReturnType<typeof setTimeout>;
	return (...args: any[]): void => {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
};

export default debounce;